<template>
  <table v-if="hasVisibleRows" class="driver-task-list" aria-label="Order task status">
    <tbody>
      <tr v-if="isSalsac && adminStatus">
        <th scope="row" class="task-label">Employee License Check</th>
        <td class="task-value">
          <span class="task-status" :class="adminStatus.check_ok ? 'is-complete' : 'is-pending'">
            {{ adminStatus.check_ok ? 'Complete' : 'Still to action' }}
          </span>
        </td>
      </tr>
      <tr v-if="isSalsac && adminStatus">
        <th scope="row" class="task-label">Salary Sacrifice Agreement</th>
        <td class="task-value">
          <span class="task-status" :class="adminStatus.agreement_signed ? 'is-complete' : 'is-pending'">
            {{ adminStatus.agreement_signed ? 'Complete' : 'Still to action' }}
          </span>
        </td>
      </tr>
      <tr v-if="showDeliveryDate && confirmedDeliveryDate">
        <th scope="row" class="task-label">Confirmed Delivery Date</th>
        <td class="task-value">{{ confirmedDeliveryDate }}</td>
      </tr>
      <tr v-if="showsDeliveryMonthRow">
        <th scope="row" class="task-label">Estimated delivery month</th>
        <td class="task-value">{{ adminStatus.delivery_month }}</td>
      </tr>
    </tbody>
  </table>
  <p v-if="showsDeliveryMonthRow" class="delivery-month-disclaimer">The estimated delivery month is subject to change and should be treated as a guide only. We will let you know if there are any significant changes to the lead time. Once the vehicle arrives in stock, we will make contact to arrange a suitable delivery date.</p>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  order: { type: Object, required: true },
  showDeliveryMonth: { type: Boolean, default: false },
  showDeliveryDate: { type: Boolean, default: false },
});

const adminStatus = computed(() => props.order.adminOrderStatus ?? null);
const isSalsac = computed(() => props.order.quote?.scheme === 'salsac');
const isBch = computed(() => props.order.quote?.scheme === 'bch');
const confirmedDeliveryDate = computed(() => props.order.delivery?.deliveryDate ?? null);

/** True when the "Estimated delivery month" row (and its disclaimer) should be shown. */
const showsDeliveryMonthRow = computed(() =>
  props.showDeliveryMonth && !!adminStatus.value && !!adminStatus.value.delivery_month && (isSalsac.value || isBch.value)
);

const hasVisibleRows = computed(() => {
  if (isSalsac.value && adminStatus.value) return true;
  if (showsDeliveryMonthRow.value) return true;
  if (props.showDeliveryDate && confirmedDeliveryDate.value) return true;
  return false;
});
</script>
